import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list (params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios.get(`${url}/stations`, options)
        .then(response => {
            console.log('data from server');
            console.log(response.data);
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function ports (station) {
    let options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };
    return axios.get(`${url}/stations/${station.id}/ports`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/stations/${id}?include=ports,tariffs,tariffs.vendor,activeTariffs,activeTariffs.vendor`, options)
        .then(response => {
            let stations = jsona.deserialize(response.data);
            delete stations.links;
            return stations;
        });
}


function show (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/stations/${id}`, options)
        .then(response => {
            let stations = jsona.deserialize(response.data);
            delete stations.links;
            return stations;
        });
}

function add (stations) {
    const payload = jsona.serialize({
        stuff: stations,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/stations`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update (stations) {
    const payload = jsona.serialize({
        stuff: stations,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/stations/${stations.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/stations/${id}`, options);
}


export default {
    list,
    get,
    show,
    add,
    update,
    ports,
    destroy
};

